export default "__VITE_ASSET__9aec456c__"